// ─── SHARED CSV HELPERS ───────────────────────────────────────────────────────
// One implementation for both the admin bulk import (Products.jsx) and the
// vendor portal batch upload (VendorPortal.jsx).

// RFC 4180-compliant parser. Handles quoted fields with embedded commas,
// escaped double-quotes (""), CRLF/LF endings, and a UTF-8 BOM — matching
// Excel / Google Sheets output. Returns an array of row objects keyed by the
// header row.
export function parseCSV(text) {
  if (text.charCodeAt(0) === 0xFEFF) text = text.slice(1); // strip BOM
  const rows = [];
  let row = [], cur = '', inQ = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQ) {
      if (ch === '"' && text[i + 1] === '"') { cur += '"'; i++; }
      else if (ch === '"') { inQ = false; }
      else { cur += ch; }
    } else {
      if (ch === '"') { inQ = true; }
      else if (ch === ',') { row.push(cur.trim()); cur = ''; }
      else if (ch === '\n') { row.push(cur.trim()); rows.push(row); row = []; cur = ''; }
      else if (ch === '\r') { /* CRLF: \n will flush */ }
      else { cur += ch; }
    }
  }
  if (cur || row.length) { row.push(cur.trim()); rows.push(row); }
  if (!rows.length) return [];
  const headers = rows[0].map(h => h.trim());
  return rows.slice(1)
    .filter(r => r.some(c => c))
    .map(cols => Object.fromEntries(headers.map((h, i) => [h, (cols[i] || '').trim()])));
}

// Decode an uploaded CSV file's bytes to text: UTF-8 first (strict), falling
// back to Windows-1256 for Arabic Excel exports.
export function decodeCsvBuffer(buf) {
  try { return new TextDecoder('utf-8', { fatal: true }).decode(buf); }
  catch { return new TextDecoder('windows-1256').decode(buf); }
}

// Trigger a client-side download of a CSV string.
export function downloadCsv(filename, csv) {
  const a = document.createElement('a');
  a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
  a.download = filename;
  a.click();
}
